import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.6);
    z-index: 200;
    display: none;

    &.opened {
        display: block;
    }
`;

export const Window = styled.div`
    display: none;
    position: fixed;
    top: calc(50% + 15px);
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 500px;
    height: 400px;
    max-height: 400px;
    background-color: #111;
    border: 1px solid #333;
    z-index: 201;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        display: flex;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    background-color: #333;
    height: 30px;
    min-height: 30px;
    width: 100%;
`;

export const HeaderTitle = styled.div`
    padding-left: 5px;
    font-size: 14px;
    text-transform: uppercase;
    color: #fff;
`;

export const ButtonBar = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #333;
    width: 100%;
    height: 71px;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    min-width: 100px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all .3s ease 0s;
    margin-left: 20px;

    :first-child {
        margin-left: 0;
    }

    :not(.inactive):hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &.inactive {
        opacity: .2;
        cursor: default;
    }
`;

export const Page = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: strtch;
    height: 299px;
    min-height: 299px;
    max-height: 299px;
    width: 100%;
`;

export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: strtch;
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 20px;
    color: #fff;
`;

export const PageText = styled.div`
    width: 100%;
    color: #999;
    font-size: 14px;
    padding: 20px 0;
    line-height: 20px;

    & a {
        text-decoration: none;
        color: #ff0;
        transition: all .3s ease 0s;
    }

    & b {
        font-weight: bold;
        color: #aaa;
    }

    & a:hover {
        color: #0f0;
    }
`;

export const PageHighlight = styled.div`
    width: 80%;
    color: #cacaca;
    font-size: 18px;
    padding: 10px 0;
    line-height: 20px;
    font-style: italic;
    text-align: center;
    margin: 0 auto;
`;

export const ResumeChart = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 80%;
    margin: 20px auto 0;
`;

export const ChartBar = styled.div`
    width: 100%;
    background-color: #555;
    height: 30px;
    margin: 5px 0;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: ${p => (p.percent+'%') ?? '0'};
        background-color: #3a3;
    }
`;

export const CurrentValue = styled.div`
    width: 100%;
    text-align: left;

    & span {
        font-size: 12px;
        color: #999;
    }
`;

export const TargetValue = styled.div`
    width: 100%;
    text-align: right;

    & span {
        font-size: 12px;
        color: #999;
    }
`;
